import Swiper from 'swiper/dist/js/swiper.min.js';
import MicroModal from 'micromodal';

export default {
  init() {
    var swiperInstances = [];
    $('.gallery-tab').each(function(index){
      let galleryThumbs = new Swiper('.swiper-container--thumbs.index-' + index, {
        spaceBetween: 10,
        slidesPerView: 14,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
          640: {
            slidesPerView: 4,
          },
          1024: {
            slidesPerView: 6,
          },
          1200: {
            slidesPerView: 10,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next--thumb-' + index,
          prevEl: '.swiper-button-prev--thumb-' + index,
        },
        keyboard: {
          enabled: true,
        },
      });
      let galleryMain = new Swiper('.swiper-container--main.index-' + index, {
        spaceBetween: 10,
        speed: 600,
        navigation: {
          nextEl: '.swiper-button-next--' + index,
          prevEl: '.swiper-button-prev--' + index,
        },
        thumbs: {
          swiper: galleryThumbs,
        },
        keyboard: {
          enabled: true,
        },
        on: {
          click: function (e) {
            const clickedSlide = this.clickedSlide;

            if (!clickedSlide) return;

            const isVideoSlide = clickedSlide.querySelector('video');
            if (isVideoSlide) {
              return;
            }

            const imageDiv = clickedSlide.querySelector('.item__image');
            if (imageDiv) {
              document.querySelector('.modal--viewbox .image').style.backgroundImage = imageDiv.style.backgroundImage;

              MicroModal.show('modal-viewbox', {
                awaitCloseAnimation: true,
                disableScroll: true,
              });
            }

            // Prevent click propagation if needed
            e.stopImmediatePropagation();
          },
        },
      });

      swiperInstances.push(galleryThumbs);
      swiperInstances.push(galleryMain);
    });

    $('.tabs').on('change.zf.tabs', function() {
      // Ensure the update is done only after the tab change and Swiper is fully visible
      setTimeout(function() {
        swiperInstances.forEach(function(swiperInstance) {
          swiperInstance.update();
        });
      }, 50); // A small delay to ensure the tab transition is fully complete
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGallery.js